import flatpickr from "flatpickr";
import React, { useEffect, useRef, useState } from "react";
import { formatDateAndTime, formatDateTime, startLoader, stopLoader } from "../../../lib/utils";
import { followResponse, getAllFollowup, getFollowup } from "../helper/api";
import { isAuthenticated } from "../../../auth";
import Toast from "../../../lib/toast";
import { getUsersList, getUsersListV2 } from "../../employees/helper/api";
// import config from "../../../config";
import client from "../../../clients";

const FollowUpResponse = (props={
	followup:null,
	selectedGym:null
}) => {

	const [userList,setUserList] = useState([]);

	const [currentElementId, setCurrentElementId] = useState("");
	const [convertibilityType, setConvertibilityType] = useState("");
	const [callResponse, setCallResponse] = useState("");
	const [callRemark, setCallRemark] = useState("");
	const trialDateAndTimeRef = useRef(null);
	const [assigneeSearch, setAssigneeSearch] = useState("");
	const [isButtonLock,setButtonLock] = useState(false);
	const Reasons = [
		"Other Gym",
		"Price Issue",
		"Call Not Answered",
		"Location Change",
		"Other"
	]

	

	const [dropDownType, setDropdownType] = useState("");

	const [scheduleFollowUp, setScheduleFollowUp] = useState({
		dateTime: "",
		dateTimeString: "",
		assignees: "",
		toDo: ""
	})

	const [notInterestedReason, setNotInterestedReason] = useState([]);
	const [followupHistoryList,setFollowUpHistoryList] = useState([]);
	const [mainFollowUp, setMainFollowUp] = useState("");
	

	const {user,token} = isAuthenticated();


	const GetUserParams = (req,res) =>{
		const params = {
			noLimit:'noLimit',
			branchIDs:[props.selectedGym._id],
			isAllUser:true,
			// roles:[5,6,7,10,2]
		};


		return params;
	}

	const GetAllUser = async () =>{
		try{
			const params = GetUserParams();
			const response = await getUsersListV2(user._id,token,params);
			if(response.error){
			}else{
				setUserList(response)
			}
		}catch(error){

		}
	}

	const GetFollowupParams = () =>{
		const params = {
			noLimit: true,
			parentId: props.followup._id
		}

		return params;
	}

	const GetAllFollowups = async (isReload) =>{
		try{
			const params = GetFollowupParams();
			const response = await getAllFollowup(user._id,token,params);
			if(!response.error) setFollowUpHistoryList(isReload?response:[...followupHistoryList,...response]);
		}catch(error){

		}
	} 


	const FollowResponse = async () =>{
		try{

			await startLoader()
			setButtonLock(true)

			const payload = {};

			if(props.followup._id){
				payload.currentFollowUpId=props.followup._id;
			}
			payload.call_remark=callRemark;
			payload.call_response=callResponse == "Successful" ? "Successful Follow Up" : callResponse;
			payload.convertibility = convertibilityType;

			if(callResponse == "Follow Up Again"){

				payload.date = new Date(scheduleFollowUp.dateTime);
				payload.dateString = formatDateTime(payload.date);
				payload.assigned_to_id =scheduleFollowUp.assignees._id;
				payload.to_do = scheduleFollowUp.toDo;
				payload.followable_type = mainFollowUp?.followable_type


			}else if(callResponse == "Not Interested"){
				payload.not_interested_reasons=notInterestedReason;
			}


			let followupId = "";

      if (callResponse === "Successful") {
        followupId = props.followup?._id ?? "";
      } else {
       followupId = followupHistoryList.length > 0 ? followupHistoryList[0]?._id ?? "" : props.followup?._id ?? "";
      }
			

			const response = await followResponse(user._id,token,followupId,payload);

			if(response.error){
				new Toast({
					type:"error",
					duration:3000,
					message:response.error
				})
			}else{
				new Toast({
					type:"success",
					duration:3000,
					message:"Followup response submitted"
				})
			}

			console.log("response");

			if(typeof props.closeReloadAndView == "function"){
				props.closeReloadAndView(response);
			}else{
				props.closeAndReload();
			}
				


			await stopLoader();

		}catch(error){
			await stopLoader()
		}

		setButtonLock(false);
	}

	const toggleInputFields = (id) => event => {
    setCurrentElementId(id);

		if (event) {
      let interval = setInterval(() => {
        let element = event.target.querySelector('input');
        if (element) {
            element.focus();
            clearInterval(interval)
        }
      }, 0);
    }

		if(dropDownType != id){
			if(id == "trial-date-and-time"){
				openDateAndTime();
			}
			setDropdownType(id);
		}else{
			setDropdownType("");
		}
  }

	const getSelectedDropdownItem = (type, value) => {
		if(type == "convertibility-type"){
			setConvertibilityType(value);
			setDropdownType("");
		}
		if(type == "call-response"){
			setCallResponse(value);
			setDropdownType("");
		}

		if(type == "assignee"){
		setScheduleFollowUp({
			...scheduleFollowUp,
			assignees:value
		})
		setAssigneeSearch("");
		setDropdownType("");
		}

		if(type == "reason"){
			setNotInterestedReason(oldState=>{
				if(value == "all"){
					if([...oldState].sort().join("-").toLowerCase().trim()==[...Reasons].sort().join("-").toLowerCase().trim()){
						oldState=[]
					}else{
						oldState=[...Reasons]
					}
				}else{
					if(oldState.indexOf(value) == -1){
						oldState.push(value)
					}else{
							oldState.splice(oldState.indexOf(value),1)
					}
				}
				return [...oldState];
			})
		}
	}

	const handleChange = (event) => {
    if(currentElementId == "to-do"){
			setScheduleFollowUp(prev => (
				{
					...prev,
					toDo: event.target.value
				}
			))
		}

		if(currentElementId == "call-remark"){
			setCallRemark(event.target.value)
		}
	}

	const openDateAndTime = () =>{

		if (!trialDateAndTimeRef.current) return;

		flatpickr(trialDateAndTimeRef.current, {
			enableTime: true,
			time_24hr: false,
			disableMobile: true,
			dateFormat: "Y-m-d h:i K",

			onChange: ([selectedDate]) => {
				if (selectedDate) {

					const formattedDate = selectedDate.toLocaleString("en-IN", {
						year: "numeric",
						month: "2-digit",
						day: "2-digit",
						hour: "2-digit",
						minute: "2-digit",
						hour12: true
					});

					setScheduleFollowUp(prev => ({
						...prev,

						// backend save
						dateTime: selectedDate,

						// UI display
						dateTimeString: formattedDate
					}));
				}
			}
		}).open();

	}

	useEffect(async() => {
		try{
			await startLoader();
			await GetAllUser();
		}catch(error){
		
		}
		await stopLoader();
	},[]);

	useEffect(()=>{
		setConvertibilityType(props.followup.convertibility);

		if(props.followup._id || !props.followup.parentId){
			GetAllFollowups();
		}

	},[props]);

	useEffect(async()=>{
		if(props.followup.parentId){
			try{
				const response = await getFollowup(user._id, token, props.followup.parentId);
				console.log("parent followup",response);

				if(!response.error){
					setMainFollowUp(response);
				}
			}catch(err){
				console.log(err)
			}
		}else{
			setMainFollowUp(props.followup);
		}
		
	},[props.followup])

	useEffect(() => {
		if(mainFollowUp != ""){
			GetAllFollowups();
		}
	},[mainFollowUp])

	useEffect(() => {
		if (userList.length > 0 && callResponse == "Follow Up Again") {
			const matchedUser = userList.find(
				data => data._id.toString() === user?._id?.toString()
			);

			if (matchedUser) {
				setScheduleFollowUp(prev => ({
					...prev,
					assignees: matchedUser
				}));
			}
		}else{
			setScheduleFollowUp(prev => ({
				...prev,
				assignees: ""
			}));
		}
	},[userList, callResponse])


	if(!props.followup){
		return <></>;
	}
	
  return(
		<div onTouchStart={(e)=>e.stopPropagation()} className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`} style={{borderRadius: window.innerWidth < 640 ? "12px 12px 0 0" : ""}}>
      <div className="global-modal-type-2 follow-up-response-modal flex-item" style={{width: window.innerWidth < 640 && "100%", height: window.innerWidth < 640 && "100%"}}>
				{/* <div className="global-modal-container d-flex">
					<div className="global-modal-type-2 follow-up-response-modal flex-item"> */}
					{
						window.innerWidth > 767 && (
							<div className="d-flex w-full space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
								<div className='d-flex'>
									<svg className='flex-item m-r-10' width="28" height="28" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M8.94576 2.52501C6.50818 3.11007 4.37558 4.65473 2.9853 6.84222C1.59502 9.02971 1.05242 11.6943 1.46876 14.2895M8.94576 2.52501L5.68355 1.125M8.94576 2.52501L7.85836 5.70395M19.8894 17.1513C20.561 15.7286 20.9094 14.1611 20.9072 12.5724C20.9072 7.46684 17.3808 3.23017 12.7517 2.41168M19.8894 17.1513L23.082 14.8618M19.8894 17.1513L18.1887 13.7171M2.98243 18.296C3.87595 19.7057 5.0863 20.8612 6.506 21.66C7.9257 22.4588 9.51082 22.8761 11.1206 22.875C13.5285 22.8782 15.8524 21.9436 17.645 20.2513M2.98243 18.296H6.77095M2.98243 18.296V22.3026" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
									<p className="flex-item fs-18 color-white font-weight-700">Follow Up Response</p>
								</div>
								<div onClick={()=>props.handleClose("")} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
									<svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
									</svg>
								</div>
							</div>
						)
					}
					{
						props.followup && props.followup.user && props.followup.user.length > 0 && (
							<div className='w-full' style={{padding:"12px 0 12px 12px", height: "92%"}}>
								<div className="w-full h-full p-r-12" style={{overflowY:"auto", paddingBottom:"100px"}}>
									<div className="d-flex w-full m-b-20">
										<div className="d-flex flex-item follow-up-response-user" style={{background:"#5D883C"}}>
											{
												props.followup?.user?.[0]?.profileID ? (
													<img className="w-full h-full" src={`${client.config.API_URL}/image/file/${props.followup.user[0].profileID}/auto/auto/70`} />
												):(
													<p className="flex-item color-white font-weight-700 margin-auto fs-18">{props.followup.userInfo.full_name.trim()[0]}</p>
												)
											}
											{/* If no image */}
											{/* <p className="flex-item color-white font-weight-700 margin-auto fs-18">U</p> */}
										</div>
										<div className="flex-item m-l-8">
											<p className="flex-item font-weight-700 fs-16" style={{lineHeight:"16px"}}>{props.followup.userInfo.full_name}</p>
											<p className="flex-item fs-13 color-grey-04 m-t-6" style={{lineHeight:"13px"}}>{props.followup.userInfo.phone}</p>
										</div>
									</div>
									<div className="d-flex m-b-12 space-between">
										<p className="flex-item flw-response-topic font-weight-500">Followed Up On</p>
										<p className="flex-item flw-response-value font-weight-700" style={{width:"65%"}}>{formatDateAndTime(new Date(props.followup.date))}</p>
									</div>
									<div className="d-flex m-b-12 space-between">
										<p className="flex-item flw-response-topic font-weight-500">Followed Up By</p>
										<p className="flex-item flw-response-value font-weight-700" style={{width:"65%"}}>{props.followup.assignedTo.length > 0 && props.followup.assignedTo[0].name ? props.followup.assignedTo[0].name : "NA"}</p>
									</div>
									<div className="d-flex m-b-12 space-between">
										<p className="flex-item flw-response-topic font-weight-500">Follow Up Type</p>
										<p className="flex-item flw-response-value font-weight-700" style={{width:"65%"}}>{props.followup.scheduled_type}</p>
									</div>
									<div onClick={toggleInputFields('convertibility-type')} className={`${(currentElementId == 'convertibility-type' || convertibilityType) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12 m-t-20`} style={{ border: (currentElementId == 'convertibility-type' || convertibilityType) ? "1px solid var(--darkBlue)" : "", width:"100%" }}>
										<div className="flex-item d-flex">
											<svg className="flex-item m-r-4" width={(currentElementId == 'convertibility-type' || convertibilityType) ? "12" : "18"} height={(currentElementId == 'convertibility-type' || convertibilityType) ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M5.37735 2.24821C5.67548 2.24821 5.9614 2.12977 6.17221 1.91896C6.38302 1.70815 6.50145 1.42223 6.50145 1.1241C6.50145 0.825972 6.38302 0.540052 6.17221 0.329242C5.9614 0.118432 5.67548 0 5.37735 0C5.07922 0 4.7933 0.118432 4.58249 0.329242C4.37168 0.540052 4.25325 0.825972 4.25325 1.1241C4.25325 1.42223 4.37168 1.70815 4.58249 1.91896C4.7933 2.12977 5.07922 2.24821 5.37735 2.24821ZM3.11915 3.31785C2.80765 3.39529 2.59507 3.5117 2.42346 3.65608C2.16616 3.87291 1.95833 4.18566 1.67755 4.67727C1.6118 4.79231 1.50304 4.87653 1.37519 4.91138C1.24735 4.94623 1.11089 4.92887 0.995847 4.86312C0.880801 4.79736 0.796589 4.6886 0.761735 4.56076C0.726881 4.43291 0.74424 4.29646 0.809995 4.18141C1.08952 3.69255 1.37205 3.23517 1.77997 2.89194C2.20563 2.53323 2.72672 2.33039 3.4294 2.2522C3.72317 2.21973 4.04641 2.22622 4.34942 2.36137C4.66742 2.5035 4.89973 2.75805 5.0581 3.09828C5.27143 3.55616 5.43006 3.82869 5.55696 3.98657C5.61816 4.06251 5.66087 4.09773 5.6851 4.11347C5.70434 4.12596 5.71258 4.12696 5.71558 4.12746C5.73731 4.12995 5.80801 4.12746 6.01484 4.03578C6.10502 3.99581 6.20344 3.94785 6.32384 3.88915L6.35257 3.87516C6.49982 3.80249 6.6484 3.73254 6.79822 3.66533C6.91917 3.61222 7.05623 3.60919 7.17942 3.65688C7.30261 3.70458 7.40189 3.79911 7.45556 3.91982C7.50922 4.04053 7.5129 4.17757 7.46579 4.30098C7.41867 4.42439 7.3246 4.52412 7.20414 4.57835C7.06531 4.64066 6.92765 4.70553 6.79122 4.77294L6.7585 4.78893C6.64334 4.84513 6.52743 4.90184 6.41877 4.9498C6.19395 5.04922 5.90668 5.15713 5.59518 5.11941C5.26644 5.07945 5.01314 4.89384 4.80456 4.64479L4.12185 5.96199L5.0661 7.19051C5.1223 7.26395 5.15703 7.35138 5.16677 7.44331L5.3746 9.44072C5.38252 9.50652 5.37726 9.57325 5.35914 9.63701C5.34102 9.70077 5.31039 9.76028 5.26903 9.81208C5.22768 9.86388 5.17644 9.90694 5.11828 9.93874C5.06012 9.97054 4.99622 9.99046 4.93029 9.99732C4.86437 10.0042 4.79773 9.99785 4.73428 9.97871C4.67082 9.95956 4.6118 9.92798 4.56067 9.8858C4.50954 9.84362 4.46731 9.79169 4.43645 9.73304C4.40558 9.67438 4.3867 9.61016 4.3809 9.54413L4.18755 7.68736L3.61401 6.94096L3.60901 6.9502L3.58803 6.90724L2.52837 5.52834C2.47628 5.46056 2.44245 5.38056 2.43012 5.29597C2.41779 5.21139 2.42736 5.12505 2.45793 5.04522L3.11915 3.31785Z" fill={(currentElementId == 'convertibility-type' || convertibilityType) ? "var(--darkBlue)" : "#6d6d6d"} />
												<path d="M2.36235 6.24658L1.99464 7.23579L0.545797 7.12088C0.479925 7.11477 0.413495 7.12179 0.35036 7.14156C0.287225 7.16132 0.228644 7.19342 0.178016 7.236C0.127387 7.27859 0.0857207 7.3308 0.0554334 7.38962C0.0251461 7.44843 0.00684141 7.51268 0.00158161 7.57862C-0.00367819 7.64457 0.00421159 7.7109 0.0247932 7.77378C0.0453747 7.83665 0.0782381 7.89481 0.121476 7.94488C0.164714 7.99495 0.217466 8.03593 0.27667 8.06545C0.335875 8.09497 0.400352 8.11244 0.466361 8.11684L2.2919 8.26172C2.40025 8.27035 2.50845 8.2434 2.60009 8.18498C2.69174 8.12655 2.76183 8.03984 2.79975 7.93798L3.08077 7.18159L2.36235 6.24658Z" fill={(currentElementId == 'convertibility-type' || convertibilityType) ? "var(--darkBlue)" : "#6d6d6d"} />
											</svg>
											<p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'convertibility-type' || convertibilityType) ? "10px" : "14px", color: (currentElementId == 'convertibility-type' || convertibilityType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Convertibility <span className='color-red'>*</span></p>
										</div>
										<div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
											<svg className="flex-item" style={{ transform: dropDownType == "convertibility-type" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
											</svg>
										</div>
										<input id='convertibility-type' className={`${(currentElementId == 'convertibility-type' || convertibilityType) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Convertibility Type" value={convertibilityType} style={{ pointerEvents: "none", textTransform: 'capitalize' }} disabled/>
										{
											dropDownType == "convertibility-type" && (
												<div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
													<div onClick={getSelectedDropdownItem.bind(this, 'convertibility-type', "Warm")} className="global-input-field-arrow-dropdown-item">
														<p className="flex-item">Warm</p>
													</div>
													<div onClick={getSelectedDropdownItem.bind(this, 'convertibility-type', "Hot")} className="global-input-field-arrow-dropdown-item">
														<p className="flex-item">Hot</p>
													</div>
													<div onClick={getSelectedDropdownItem.bind(this, 'convertibility-type', "Cold")} className="global-input-field-arrow-dropdown-item">
														<p className="flex-item">Cold</p>
													</div>
												</div>
											)
										}
									</div>
									<div onClick={toggleInputFields('call-response')} className={`${(currentElementId == 'call-response' || callResponse) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'call-response' || callResponse) ? "1px solid var(--darkBlue)" : "", width:"100%" }}>
										<div className="flex-item d-flex">
											<p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'call-response' || callResponse) ? "10px" : "14px", color: (currentElementId == 'call-response' || callResponse) ? "var(--darkBlue)" : "", transition: "180ms" }}>Call Response <span className='color-red'>*</span></p>
										</div>
										<div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
											<svg className="flex-item" style={{ transform: currentElementId == 'call-response' ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
											</svg>
										</div>
										<input id='call-response' className={`${(currentElementId == 'call-response' || callResponse) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Convertibility Type" value={callResponse} style={{ pointerEvents: "none", textTransform: 'capitalize' }} disabled/>
										{
											dropDownType == "call-response" && (
												<div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
													<div onClick={getSelectedDropdownItem.bind(this, 'call-response', "Follow Up Again")} className="global-input-field-arrow-dropdown-item">
														<p className="flex-item">Follow Up Again</p>
													</div>
													<div onClick={getSelectedDropdownItem.bind(this, 'call-response', "Successful")} className="global-input-field-arrow-dropdown-item">
														<p className="flex-item">Successful</p>
													</div>
													<div onClick={getSelectedDropdownItem.bind(this, 'call-response', "Not Interested")} className="global-input-field-arrow-dropdown-item">
														<p className="flex-item">Not Interested</p>
													</div>
												</div>
											)
										}
									</div>
									
									{
										callResponse == "Follow Up Again" && (
											<div className="w-full m-t-20">
												<p className="fs-16 color-dark-blue font-weight-700 m-b-8">Schedule Follow Up</p>	
												<div className="d-flex space-between">
													<div onClick={toggleInputFields('trial-date-and-time')} className={`${(currentElementId == 'trial-date-and-time' || scheduleFollowUp.dateTime) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'trial-date-and-time' || scheduleFollowUp.dateTime) ? "1px solid var(--darkBlue)" : "", width:"49%" }}>
														<div className="flex-item d-flex">
															<p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'trial-date-and-time' || scheduleFollowUp.dateTime) ? "10px" : "14px", color: (currentElementId == 'trial-date-and-time' || scheduleFollowUp.dateTime) ? "var(--darkBlue)" : "", transition: "180ms" }}>Date & Time</p>
														</div>
														<input ref={trialDateAndTimeRef} readOnly value={scheduleFollowUp.dateTimeString ?  formatDateAndTime(new Date(scheduleFollowUp.dateTime)) : ""} style={{color: "#2b2b2b", pointerEvents:"none"}} className={`${(currentElementId == 'trial-date-and-time' || scheduleFollowUp.dateTime) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='YYYY-MM-DD  HH:MM' />
													</div>

													<div onClick={toggleInputFields('assignee')} className={`${(currentElementId == 'assignee' || scheduleFollowUp.assignees) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'assignee' || scheduleFollowUp.assignees) ? "1px solid var(--darkBlue)" : "", width:"49%" }}>
														<div className="flex-item d-flex">
															<p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'assignee' || scheduleFollowUp.assignees) ? "10px" : "14px", color: (currentElementId == 'assignee' || scheduleFollowUp.assignees) ? "var(--darkBlue)" : "", transition: "180ms" }}>Assignee</p>
														</div>
														<div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
															<svg className="flex-item" style={{ transform: dropDownType == "convertibility" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
															</svg>
														</div>
														<input readOnly id='assignee' className={`${(currentElementId == 'assignee' || scheduleFollowUp.assignees) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Assignee" value={scheduleFollowUp.assignees?scheduleFollowUp.assignees.name:''} style={{ pointerEvents: "none", textTransform: 'capitalize' }} disabled/>
														{
															dropDownType == "assignee" && (
																<div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border:"1px solid #f5f5f5", padding:"0"}}>
																	<div onClick={e => e.stopPropagation()} className="w-full" style={{padding:"8px", backgroundColor:"#f5f5f5", position:"sticky", top:0}}>
																		<div className="search-container d-flex space-between" style={{width:"100%", background:"#ffffff"}}>
																			<div className="d-flex w-full">
																				<svg className="flex-item m-r-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																					<path d="M21 21L16.657 16.657M16.657 16.657C17.3999 15.9141 17.9892 15.0322 18.3912 14.0615C18.7933 13.0909 19.0002 12.0506 19.0002 11C19.0002 9.9494 18.7933 8.90908 18.3913 7.93845C17.9892 6.96782 17.3999 6.08589 16.657 5.343C15.9141 4.60011 15.0322 4.01082 14.0616 3.60877C13.0909 3.20673 12.0506 2.99979 11 2.99979C9.94942 2.99979 8.90911 3.20673 7.93848 3.60877C6.96785 4.01082 6.08591 4.60011 5.34302 5.343C3.84269 6.84333 2.99982 8.87821 2.99982 11C2.99982 13.1218 3.84269 15.1567 5.34302 16.657C6.84335 18.1573 8.87824 19.0002 11 19.0002C13.1218 19.0002 15.1567 18.1573 16.657 16.657Z" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
																				</svg>
																				<input type="text"	autoFocus	value={assigneeSearch}	onChange={e => setAssigneeSearch(e.target.value)}	placeholder={`Search Assignee by “Name“`}	className="flex-item search-input"	style={{width:"85%"}}/>
																			</div>
																		</div>
																	</div>
																	<div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
																		{
																			userList
																				.filter(u => (u.name || "NA").toLowerCase().includes(assigneeSearch.trim().toLowerCase()))
																				.map(userdata => (
																					<div key={userdata._id} onClick={getSelectedDropdownItem.bind(this, 'assignee', userdata)} className="global-input-field-arrow-dropdown-item">
																						<p className="flex-item">{userdata.name ? userdata.name : "NA"}</p>
																					</div>
																				))
																		}
																	</div>
																</div>
															)
														}
													</div>
												</div>

												<div onClick={toggleInputFields('to-do')} className={`${(currentElementId == 'to-do' || scheduleFollowUp.toDo) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'to-do' || scheduleFollowUp.toDo) ? "1px solid var(--darkBlue)" : "", width: "48.5%" }}>
													<div className="flex-item d-flex">
														<p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'to-do' || scheduleFollowUp.toDo) ? "10px" : "14px", color: (currentElementId == 'to-do' || scheduleFollowUp.toDo) ? "var(--darkBlue)" : "", transition: "180ms" }}>To Do</p>
													</div>
													<input onChange={handleChange} value={scheduleFollowUp.toDo} style={{color: "#2b2b2b", pointerEvents:"none"}} className={`${(currentElementId == 'to-do' || scheduleFollowUp.toDo) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='To Do' />
												</div>
											</div>
										)
									}

									{
										callResponse == "Not Interested" && (
											<div className="w-full m-b-20">
												<div onClick={toggleInputFields('reason')} className={`${(currentElementId == 'reason' || notInterestedReason.length > 0) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'reason' || notInterestedReason.length > 0) ? "1px solid var(--darkBlue)" : "", width:"100%" }}>
													<div className="flex-item d-flex">
														<p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'reason' || notInterestedReason.length > 0) ? "10px" : "14px", color: (currentElementId == 'reason' || notInterestedReason.length > 0) ? "var(--darkBlue)" : "", transition: "180ms" }}>Reason</p>
													</div>
													<div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
														<svg className="flex-item" style={{ transform: dropDownType == "convertibility" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
														</svg>
													</div>
													<input id='reason' className={`${(currentElementId == 'reason' || notInterestedReason.length > 0) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Your Reason" value={`${notInterestedReason.length} Reasons Selected`} style={{ pointerEvents: "none", textTransform: 'capitalize' }} disabled/>
													{
														dropDownType == "reason" && (
															<div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1" onClick={e=>e.stopPropagation()}>
																<div onClick={getSelectedDropdownItem.bind(this, 'reason', "all")} checked={notInterestedReason.every(data=>Reasons.indexOf(data)!=-1)} className="global-input-field-arrow-dropdown-item d-flex">
																	<input className="flex-item m-r-12" type="checkbox" style={{width:"16px", height:"16px"}} />
																	<p className="flex-item">[Select all]</p>
																</div>
																{
																	Reasons.map(reason=>{
																		return(
																			<div onClick={getSelectedDropdownItem.bind(this, 'reason', reason)} className="global-input-field-arrow-dropdown-item d-flex">
																				<input className="flex-item m-r-12" checked={notInterestedReason.indexOf(reason) != -1} type="checkbox" style={{width:"16px", height:"16px"}} />
																				<p className="flex-item">{reason}</p>
																			</div>
																		)
																	})
																}
															</div>
														)
													}
												</div>
											</div>
										)
									}

									<div onClick={toggleInputFields('call-remark')} className={`${(currentElementId == 'call-remark' || callRemark) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'call-remark' || callRemark) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
										<div className="flex-item d-flex">
											<p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'call-remark' || callRemark) ? "10px" : "14px", color: (currentElementId == 'call-remark' || callRemark) ? "var(--darkBlue)" : "", transition: "180ms" }}>Call Remarks <span className='color-red'>*</span></p>
										</div>
										<input onChange={handleChange} value={callRemark} style={{color: "#2b2b2b", pointerEvents:"none"}} className={`${(currentElementId == 'call-remark' || callRemark) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='' />
									</div>
									
								</div>
							</div>
						)
					}
				<div className="w-full" style={{position:"absolute", bottom:0, padding:"12px", background:"#f2f2f2", borderRadius:"0 0 16px 16px"}}>
						<div onClick={isButtonLock?null:FollowResponse} className={`global-button-container ${isButtonLock?'global-button-container-inactive':'global-button-container-active'} d-flex flex-item`} style={{borderRadius:"20px"}}>
							<p className="flex-item">Confirm</p>
						</div>
        	</div>
			</div>
		</div>
  )
}

export default FollowUpResponse;